import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Ravi Rathore </span>
            from <span className="purple"> Agra, India.</span>
            <br />
            I am currently employed as a Senior Programmer Analyst at
            Dotsquares.
            <br />
            I have completed my BCA at Swami Vivekanand Subharti University,
            Meerut. I have also done a diploma in Computer Science from the
            Board of Technical Education, Lucknow.
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Cricket
            </li>
            <li className="about-activity">
              <ImPointRight /> Reading Blogs
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "In a journey to become better Everyday!!"{" "}
          </p>
          <footer className="blockquote-footer">Ravi Rathore</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
